import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import injectSheet from 'react-jss';
import { compose } from 'redux';
import { reduxForm, Field } from 'redux-form';
import Dialog from '../Dialog';
import Section from '../Section';
import { getTextColorsFromSection } from '../lib/colors';
import Typography from '../Typography';
import LinkButton from '../LinkButton';
import TextInput from '../TextInput';
import { required, email, phone } from '../lib/validate';
import { normalizeAll, lowerCase, trim } from '../lib/normalize';

class WelcomeMatExtension extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    site: PropTypes.object.isRequired,
    section: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    loading: PropTypes.bool,
    success: PropTypes.bool,
  };

  static defaultProps = {
    onSubmit: undefined,
    loading: false,
    success: false,
  };

  render() {
    const {
      classes,
      event,
      site,
      section,
      handleSubmit,
      onSubmit,
      loading,
      success,
      ...dialogProps
    } = this.props;
    const { data, styles } = section;
    const buttons = data.buttons && data.buttons.slice(0, 1);
    const colors = getTextColorsFromSection(site, section);
    return (
      <Dialog {...dialogProps} className={classes.dialog}>
        <Section site={site} section={section} withPadding rootClassName={classes.sectionRoot}>
          <Typography type="title" paragraph style={{ ...colors.title, ...styles.title }}>
            {data.title}
          </Typography>
          <Typography paragraph style={{ ...colors.text, ...styles.description }}>
            {data.description}
          </Typography>
          <form className={classes.form} onSubmit={handleSubmit}>
            <Field
              className={classes.formField}
              component={TextInput}
              name="name"
              placeholder={data.namePlaceholder}
              validate={required}
            />
            <Field
              className={classes.formField}
              component={TextInput}
              name="email"
              placeholder={data.emailPlaceholder}
              validate={[required, email]}
              normalize={normalizeAll([lowerCase, trim])}
            />
            {Boolean(data.phoneEnabled) && (
              <Field
                className={classes.formField}
                component={TextInput}
                name="phone"
                placeholder={data.phonePlaceholder}
                validate={[required, phone]}
                normalize={normalizeAll([lowerCase, trim])}
              />
            )}
            {buttons &&
              buttons.map((button, i) => (
                <LinkButton
                  key={button.id || i}
                  section={section}
                  site={site}
                  event={event}
                  button={button}
                  className={classes.formButton}
                  component="button"
                  disabled={Boolean(!onSubmit || loading || success)}
                  style={styles.buttons && styles.buttons[i]}
                  success={success}
                >
                  {success && <FormattedMessage id="sent" />}
                  {!success && button.title}
                </LinkButton>
              ))}
          </form>
        </Section>
      </Dialog>
    );
  }
}

const styles = theme => ({
  dialog: {
    padding: 0,
  },
  sectionRoot: {
    padding: 5 * theme.spacing.unit,
    [theme.breakpoints.down('sm')]: {
      height: '100%',
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  formField: {
    height: 7 * theme.spacing.unit,
    margin: [[theme.spacing.unit, 0]],
  },
  formButton: {
    maxWidth: 280,
    display: 'block',
    width: '100%',
    margin: [[theme.spacing.unit, 'auto']],
  },
  closeIcon: {
    cursor: 'pointer',
    position: 'absolute',
    right: theme.spacing.unit,
    zIndex: 1,
  },
});

export default compose(
  injectSheet(styles),
  reduxForm({ form: 'welcome' }),
)(WelcomeMatExtension);



// WEBPACK FOOTER //
// ./src/site-render/src/WelcomeMatExtension/WelcomeMatExtension.js